angular.module('app').directive('topfiveindupopup', function () {
  function link (scope) {
    scope.closeClickHandler = function () {
      scope.toggleFunction(false);
    };

    scope.formsColOptionStyles = {
      topWrapper: {
        width: '100px',
      },
      name: {
        'font-size': '12px'
      }
    }

    scope.newmoodboard = () => {
      const data = {
        type: 'brand'
      }  
      scope.$emit("mood_state_chart", data);
    };

    scope.shareFacebook = (url) => {
      window.open("https://www.facebook.com/sharer/sharer.php?u=" + url);
    };

    scope.shareTwitter = (url) => {
      window.open("https://twitter.com/home?status=" + url);
    };

    scope.sharePinterest = (url) => {
      window.open("https://pinterest.com/pin/create/button/?url=" + url);
    };

    scope.shareInstagram = (url) => {
      window.open("https://instagram.com/?url=" + url);
    };

  }

  return {
    restrict: 'E',
    templateUrl: 'app/directives/topFiveInduPopup/topFiveInduPopup.html',
    link: link,
    scope: {
      colors:'=',
      typeOfPopup:'=',
      colorData:'=',
      brandColorHeaderData:'=',
      mainColor:'=',
      toggleFunction:'=',
      selectedItem: '=',
      mainData: '=',
      modalTitle:'=',
      modalSecondTitle:'=',
      industryTopColors:'=',
      industryLogoData:'=',
      formsColWidth:'=',
      colorComparedInPeriodData:'=',
      colorFrequencyDummyData:'='
    }
  };
});
